module.exports = __webpack_public_path__ + "static/media/illuEuropraid2018_02_thumb.07e6e9ec.png";